import { render, staticRenderFns } from "./Demerit-Points.vue?vue&type=template&id=0f5de907"
import script from "./Demerit-Points.vue?vue&type=script&lang=js"
export * from "./Demerit-Points.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports